/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LearningPlanTaskStatus } from '../models/LearningPlanTaskStatus';
import type { LearningPlanTopic } from '../models/LearningPlanTopic';
import type { LearningPlanTopicParams } from '../models/LearningPlanTopicParams';
import type { MasteredSection } from '../models/MasteredSection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LearningPlanService {
    /**
     * Get all learning plan task statuses
     * @returns LearningPlanTaskStatus successful
     * @throws ApiError
     */
    public static getAllLearningPlanTaskStatuses(): CancelablePromise<Array<LearningPlanTaskStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/learning_plan_task_statuses.json',
        });
    }
    /**
     * Create or update learning plan task status
     * @param requestBody
     * @returns LearningPlanTaskStatus successful
     * @throws ApiError
     */
    public static createOrUpdateLearningPlanTaskStatus(
        requestBody?: LearningPlanTaskStatus,
    ): CancelablePromise<LearningPlanTaskStatus> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/learning_plan_task_statuses.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all learning plan topics
     * @returns LearningPlanTopic successful
     * @throws ApiError
     */
    public static getAllLearningPlanTopics(): CancelablePromise<Array<LearningPlanTopic>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/learning_plan_topics.json',
        });
    }
    /**
     * Bulk update learning plan topics
     * @param requestBody
     * @returns LearningPlanTopic successful
     * @throws ApiError
     */
    public static bulkUpdateLearningPlanTopics(
        requestBody?: {
            learningPlanTopics: Array<LearningPlanTopicParams>;
        },
    ): CancelablePromise<Array<LearningPlanTopic>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/learning_plan_topics/bulk_update.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update learning plan topic
     * @param id Topic ID
     * @param requestBody
     * @returns LearningPlanTopic successful
     * @throws ApiError
     */
    public static updateLearningPlanTopic(
        id: string,
        requestBody?: LearningPlanTopicParams,
    ): CancelablePromise<LearningPlanTopic> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/learning_plan_topics/{id}.json',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all mastered sections
     * @returns MasteredSection successful
     * @throws ApiError
     */
    public static getAllMasteredSections(): CancelablePromise<Array<MasteredSection>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/mastered_sections.json',
        });
    }
    /**
     * Update mastered section
     * @param id Section ID
     * @param requestBody
     * @returns MasteredSection successful
     * @throws ApiError
     */
    public static updateMasteredSection(
        id: string,
        requestBody?: {
            mastered: boolean;
        },
    ): CancelablePromise<MasteredSection> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/mastered_sections/{id}.json',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
